const chargifyConfig = {
  selector: '#chargify',
  type: 'card',
  hideCardImage: true,
  optionalLabel: ' ',
  requiredLabel: '*',
  fields: {
    number: {
      selector: '#chargify-card-number',
      label: 'Credit Card Number',
      placeholder: 'Credit Card Number',
      required: true,
    },
    month: {
      selector: '#chargify-exp-month',
      label: 'Exp. Month',
      placeholder: 'Exp. Month (mm)',
      required: true,
    },
    year: {
      selector: '#chargify-exp-year',
      label: 'Exp. Year',
      placeholder: 'Exp. Year (yyyy)',
      required: true,
    },
    cvv: {
      selector: '#chargify-card-cvv',
      label: 'CVV code',
      placeholder: 'Security Code',
      required: true,
    },
  },
  style: {
    field: {
      margin: '0',
    },
    input: {
      padding: '12px',
      lineHeight: 'initial',
      border: '1px solid #cccccc',
      margin: '6px 4px',
      width: 'calc(100% - 8px)',
      placeholder: { color: '#7B7B7B' },
      backgroundColor: 'inherit',
      color: '#787878',
    },
    label: {
      fontWeight: '500',
      fontSize: '12px',
      padding: '0 18px',
      margin: '0',
      color: '#787878',
      display: 'none'
    },
  },
};
export default chargifyConfig;
